// Shared texts for the activity-item family. Many entries are split into a
// prefix/suffix around a candidate or project link, so word order can differ
// between languages (e.g. German "hat <name> abgelehnt" vs English
// "rejected <name>").
export const texts = {
  commentedPrefix: { de: 'hat', en: 'commented on' },
  commentedSuffix: { de: 'kommentiert', en: '' },
  referenceReviewPrefix: { de: 'hat Feedback zu', en: 'gave feedback on' },
  referenceReviewSuffix: { de: 'gegeben', en: '' },
  referenceReviewShort: { de: 'hat Feedback gegeben', en: 'gave feedback' },
  referenceAcceptedPrefix: { de: 'hat', en: 'marked' },
  referenceAcceptedSuffix: { de: 'als passend markiert', en: 'as a match' },
  referenceAcceptedShort: { de: 'hat das Profil als passend markiert', en: 'marked the profile as a match' },
  referenceRejectedPrefix: { de: 'hat', en: 'marked' },
  referenceRejectedSuffix: { de: 'als unpassend markiert', en: 'as no match' },
  referenceRejectedShort: { de: 'hat das Profil als unpassend markiert', en: 'marked the profile as no match' },
  // marks the reviewed items whose label alone doesn't tell where they come from
  referenceReviewItemPrefixes: {
    experience: { de: 'BE', en: 'EXP' },
    education: { de: 'BA', en: 'EDU' }
  },

  commentedPosition: { de: 'hat die Stelle kommentiert', en: 'commented on the position' },

  acceptedPrefix: { de: 'hat', en: 'selected' },
  acceptedSuffix: { de: 'für ein Kennenlernen ausgewählt', en: 'for an interview' },
  unknownCandidate: { de: 'eine unbekannte Kandidat:in', en: 'an unknown candidate' },

  feedbackPrefix: { de: 'hat eine Einschätzung zu', en: 'submitted an assessment of' },
  feedbackSuffix: { de: 'abgegeben', en: '' },
  feedbackCandidateContext: { de: 'hat eine Einschätzung abgegeben', en: 'submitted an assessment' },

  hiredPrefix: { de: 'hat', en: 'marked' },
  hiredSuffix: { de: "als 'Eingestellt' markiert", en: "as 'Hired'" },

  rejectedPrefix: { de: 'hat', en: 'rejected' },
  rejectedSuffix: { de: 'abgelehnt', en: '' },

  shortlistedPrefix: { de: 'hat', en: 'shortlisted' },
  shortlistedSuffix: { de: 'auf die Shortlist gesetzt', en: '' },
  shortlistedByPrefix: { de: 'Von', en: 'Shortlisted by' },
  shortlistedBySuffix: { de: 'auf die Shortlist gesetzt', en: '' },

  addedToPoolPrefix: { de: 'hat', en: 'added' },
  addedToPoolSuffix: { de: 'zum Pool hinzugefügt', en: 'to the pool' },

  jobsiteCommentedShort: { de: 'hat die Jobsite kommentiert', en: 'commented on the jobsite' },
  jobsiteCommentedPrefix: { de: 'hat die Jobsite', en: 'commented on the jobsite' },
  jobsiteCommentedFor: { de: 'für', en: 'for' },
  jobsiteCommentedSuffix: { de: 'kommentiert', en: '' },
  genderSuffix: { de: 'm|w|d', en: 'm|f|d' },

  jobsiteConfirmed: { de: 'hat die Jobsite freigegeben', en: 'approved the jobsite' },

  jobsiteReadyLinkPrefix: { de: 'hat die', en: 'completed the' },
  jobsiteReadyLinkSuffix: { de: 'fertiggestellt', en: '' },
  jobsiteReady: { de: 'hat die Jobsite fertiggestellt', en: 'completed the jobsite' },
  jobsiteLink: { de: 'Jobsite', en: 'Jobsite' },

  messagingDone: { de: 'hat die Kandidatenansprache abgeschlossen', en: 'completed the candidate outreach' },

  briefingCompleted: { de: 'das Briefing ist abgeschlossen', en: 'the briefing is complete' },

  projectCreated: { de: 'hat die Stelle angelegt', en: 'created the position' },

  profileFeedbackSubmitted: { de: 'hat Feedback zu den Referenzprofilen gegeben', en: 'submitted feedback on the reference profiles' },

  analysisRequested: { de: 'hat eine Potenzialanalyse angefordert', en: 'requested a potential analysis' },
  analysisCreated: { de: 'hat die Potenzialanalyse fertiggestellt', en: 'completed the potential analysis' },
  analysisMatchesPrefix: { de: 'Es wurden', en: 'Found' },
  analysisMatchesSuffix: { de: 'passende Talente gefunden.', en: 'matching talents.' },
  analysisLink: { de: 'Analyse ansehen', en: 'View analysis' },

  companyPoolOnboarding: { de: 'hat sich für den Talentpool registriert', en: 'joined the talent pool' },
  companyPoolOnboardingCandidateContext: { de: 'Für den Talentpool registriert', en: 'Joined the talent pool' },

  poolSignalPrefix: { de: 'Engagement mit', en: 'Engagement with' },
  poolSignalCandidateContext: { de: 'Engagement', en: 'Engagement' },
  poolSignalSignal: { de: 'Signal', en: 'Signal' },
  poolSignalAction: { de: 'Aktion', en: 'Action' }
};
